export default __webpack_public_path__ + "static/media/info.80c1591a.svg";